import { ActionGroupTypes, ActionStatusTypes } from "../../../enum/ActionStatusTypes";
import * as logger from "../../../logger";
import { getNodeById } from "../../../nodeSelector";
import * as nodeUtils from "../../../utils/nodeUtils";
import * as systemUtils from "../../../utils/systemUtils";
import { ACTION_PREFIX_FUNCTION } from "./abstract/functionAbstract";
import { getFunctionReferences } from "./helpers/functionHelper";

const _action = `${ACTION_PREFIX_FUNCTION}_move_flat`;
const _header = `Move function`;

export const moveFunctionFlat = (root, id, idDestinationParent, indexDestination) => {
  const _payload = moveFunctionFlatLogic(root, id, idDestinationParent, indexDestination);

  logger.logAction(_action, _payload, ACTION_PREFIX_FUNCTION);

  return { root, info: _payload };
};

//--------------------------------------------------------------------------------

const moveFunctionFlatLogic = (root, id, indexDestination) => {
  const { data: _node, index: _index } = getNodeById(root, id);
  if (!_node) {
    throw new Error("Function to move not found");
  }
  const { data: _nodeCopy } = nodeUtils.copy(_node);

  const _nodeBackup = systemUtils.createDeepCopy(_node);
  const _references = getFunctionReferences(root, _node);

  detachNode(root, id);
  attachNode(root, _nodeCopy, indexDestination);

  return generatePayload(_nodeBackup, _index, indexDestination, _references.description);
};

const detachNode = (root, id) => {
  const fun = (e) => e.filter((f) => nodeUtils.getID(f) !== id);
  nodeUtils.modifyFunctions(root, fun, true);
};

const attachNode = (root, nodeCopy, index) => {
  const funAdd = (e) => e.push(nodeCopy);
  const funPosition = (e) => e.splice(index, 0, nodeCopy);
  const fun = (e) => (!index && index !== 0 ? funAdd(e) : funPosition(e));
  nodeUtils.modifyFunctions(root, fun, false);
};

//--------------------------------------------------------------------------------

const generatePayload = (node, index, indexDestination, uuidReferences) => {
  const _payload = {
    group: ActionGroupTypes.UPDATE,
    status: ActionStatusTypes.SUCCESS,
    action: _action,
    time: systemUtils.getTimestamp(),
    header: _header,
    description: generatePayloadDescription(node),
    node: node,
    uuid: nodeUtils.getUUID(node),
    indexBefore: index,
    indexAfter: indexDestination,
  };

  return { ..._payload, ...uuidReferences };
};

const generatePayloadDescription = (node) => {

  return `Move function '${nodeUtils.getName(node)}'.`;
}